var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['background-box', _vm.backgroundBox]},[(_vm.isActive)?_c('div',{staticClass:"deleteButton",on:{"click":_vm.deleteBox}}):_vm._e(),_c('router-link',{staticClass:"box-list",attrs:{"to":{
      path: _vm.to,
      query: { search: _vm.name },
    }}},[_c('div',{staticClass:"box"},[_vm._v(_vm._s(_vm.name))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }